export default __webpack_public_path__ + "fonts/VideoJS.f72fc39.eot";